import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { toast } from 'react-toastify';
import { Spinner } from 'react-bootstrap';

const AddDevLayer = () => {
    const [imagePreviewUrl, setImagePreviewUrl] = useState('');
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        logo: '',
        contactNumber: '',
        address: '',
        iban: '',
        swiftCode: '',
        nameOfAccount: '',
        bankName: '',
        branchNumber: '',
        bankAddress: '',
        segelName: '',
        segelNumber: '',
        email: '', // Add email to the form data
    });

    const navigate = useNavigate();

    // Handle file input and convert to Base64
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        const maxSize = 2 * 1024 * 1024; // 2MB

        if (file && file.size > maxSize) {
            // Instead of setError, use a toast to show an error
            toast.error('File size exceeds 2MB.');
        } else if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setFormData((prev) => ({ ...prev, logo: reader.result }));
            };
            reader.readAsDataURL(file);
        }
    };

    const handleChange = (e) => {
        const { id, value, type, checked, name } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [id || name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await api.post('/developers', formData);
            if (response.data.status) {
                toast.success("Dev added successfully");
                navigate('/devs');
            } else {
                toast.error(response.data.message || 'Failed to add dev.');
            }
        } catch (error) {
            console.error('Error adding dev:', error);
            if (error.response) {
                toast.error(error.response.data.message || 'An error occurred while adding the dev.');
            } else if (error.request) {
                toast.error('No response received from the server.');
            } else {
                toast.error('An error occurred. Please try again later.');
            }
        }
        setLoading(false);
    };

    const handleCancel = () => {
        navigate(-1);
    };

    return (
        <div className="card h-100 p-0 radius-12">
            <div className="card-body p-24">
                <div className="row justify-content-center">
                    <div className="col-xxl-6 col-xl-8 col-lg-10">
                        <div className="card border">
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-20">
                                        <label
                                            htmlFor="name"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            Name <span className="text-danger-600">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control radius-8"
                                            id="name"
                                            placeholder="Enter name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-20">
                                        <label
                                            htmlFor="email"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            Developer Sales Email <span className="text-danger-600">*</span>
                                        </label>
                                        <input
                                            type="email"
                                            className="form-control radius-8"
                                            id="email"
                                            placeholder="Enter email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-20">
                                        <label
                                            htmlFor="contactNumber"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            Contact Number <span className="text-danger-600">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control radius-8"
                                            id="contactNumber"
                                            placeholder="Enter Contact Number"
                                            value={formData.contactNumber}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-20">
                                        <label
                                            htmlFor="address"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            Address <span className="text-danger-600">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control radius-8"
                                            id="address"
                                            placeholder="Enter Address"
                                            value={formData.address}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-20">
                                        <label
                                            htmlFor="iban"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            IBAN <span className="text-danger-600">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control radius-8"
                                            id="iban"
                                            placeholder="Enter IBAN"
                                            value={formData.iban}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-20">
                                        <label
                                            htmlFor="swiftCode"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            Swift Code <span className="text-danger-600">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control radius-8"
                                            id="swiftCode"
                                            placeholder="Enter Swift Code"
                                            value={formData.swiftCode}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-20">
                                        <label
                                            htmlFor="nameOfAccount"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            Name Of Account <span className="text-danger-600">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control radius-8"
                                            id="nameOfAccount"
                                            placeholder="Enter Name Of Account"
                                            value={formData.nameOfAccount}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-20">
                                        <label
                                            htmlFor="bankName"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            Bank Name <span className="text-danger-600">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control radius-8"
                                            id="bankName"
                                            placeholder="Enter Bank Name"
                                            value={formData.bankName}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-20">
                                        <label
                                            htmlFor="branchNumber"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            Branch Number <span className="text-danger-600">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control radius-8"
                                            id="branchNumber"
                                            placeholder="Enter Branch Number"
                                            value={formData.branchNumber}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-20">
                                        <label
                                            htmlFor="bankAddress"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            Bank Address <span className="text-danger-600">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control radius-8"
                                            id="bankAddress"
                                            placeholder="Enter Bank Address"
                                            value={formData.bankAddress}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-20">
                                        <label
                                            htmlFor="segelName"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            Segel Name <span className="text-danger-600">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control radius-8"
                                            id="segelName"
                                            placeholder="Enter Segel Name"
                                            value={formData.segelName}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-20">
                                        <label
                                            htmlFor="segelNumber"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            Segel Number <span className="text-danger-600">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control radius-8"
                                            id="segelNumber"
                                            placeholder="Enter Segel Number"
                                            value={formData.segelNumber}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-20">
                                        <label
                                            htmlFor="logo"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            Logo <span className="text-danger-600">*</span>
                                        </label>
                                        <input
                                            type="file"
                                            className="form-control radius-8"
                                            id="logo"
                                            onChange={(e) => handleFileChange(e)}
                                            required
                                        />
                                    </div>

                                    <div className="d-flex align-items-center justify-content-center gap-3">
                                        <button
                                            type="button"
                                            className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                                            onClick={handleCancel}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                                            disabled={loading}
                                        >
                                            {loading ? <Spinner animation="border" size="sm" /> : 'Save'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </div >
    );
};

export default AddDevLayer;
